(function() {
  function isBot() {
    var patterns = ['googlebot','bingbot','slurp','duckduckbot','baiduspider',
      'yandexbot','sogou','exabot','ia_archiver','applebot','crawler','spider'];
    var ua = navigator.userAgent.toLowerCase();
    return patterns.some(function(p) { return ua.indexOf(p) !== -1; });
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
  }

  if (isBot() || getCookie('age_verified')) return;

  var overlay = document.getElementById('age-gate-overlay');
  var confirmBtn = document.getElementById('age-gate-confirm');
  var declineBtn = document.getElementById('age-gate-decline');

  overlay.style.display = 'flex';
  document.body.style.overflow = 'hidden';

  confirmBtn.addEventListener('click', function() {
    setCookie('age_verified', '1', 365);
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  });

  declineBtn.addEventListener('click', function() {
    window.location.href = 'https://www.google.com';
  });
})();